var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueSelect',_vm._b({staticClass:"select-wrapper",attrs:{"transition":""},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},'VueSelect',_vm.$attrs,false),[_c('div',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v(_vm._s(_vm.noHitsText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }